import { Actions } from '../../interfaces'

import find from './find'
import { Variant } from '@/entities/settings'

export const actions: Actions = {
  find,
}

export default {
  Model: { Variant },
  actions: { [Variant.name]: actions },
}
